<template>
  <section>
    <navbar-public></navbar-public>
    <div class="ew-smaller-container">
      <div class="ew-card">
        <h1 class="ew-thank__title">¡Gracias! ¡Tu mensaje llegó a su destino!</h1>
        <p class="ew-thank__subtitle">Pronto un asesor responderá tus inquietudes</p>
        <img src="@/assets/images/camion.gif" alt="" class="ew-result-indicator">

        <div class="ew-thank__social">
          <p class="ew-thank__social-label">Síguenos en redes sociales</p>
          <a href="https://www.facebook.com/enviosweb.mx/" class="ew-social-icon" target="_blank">
            <img src="@/assets/images/Facebook - color.svg" alt="">
          </a>
          <a href="https://www.instagram.com/enviosweb/" class="ew-social-icon" target="_blank">
            <img src="@/assets/images/Instagram - color.svg" alt="">
          </a>
          <a href="https://www.youtube.com/channel/UCLwSwMd-czMjC60ajlv-zzQ" class="ew-social-icon" target="_blank">
            <img src="@/assets/images/youtube-color.svg" alt="">
          </a>
        </div>
      </div>
    </div>
    <call-float-button></call-float-button>
  </section>
</template>

<script>
import NavbarPublic from './Header/NavbarPublic'
import CallFloatButton from './Header/CallFloatButton'

export default {
  name: 'ThankPage',
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  },
  computed: {},
  components: {
    'navbar-public': NavbarPublic,
    'call-float-button': CallFloatButton
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 600px; margin: 6rem auto; padding: 0 1rem; }
.ew-card { @include ew-card; padding: 2rem 1.75rem; text-align: center; }

.ew-thank__title {
  font-family: var(--app-font);
  font-weight: 700;
  font-size: 1.5rem;
  color: var(--app-navy);
  border-bottom: 1px solid var(--app-border);
  padding-bottom: 1rem;
  margin-bottom: 0.75rem;
}

.ew-thank__subtitle {
  font-family: var(--app-font);
  color: var(--app-navy-secondary);
}

.ew-result-indicator {
  width: 18rem;
  max-width: 100%;
  margin: 1.5rem 0;
}

.ew-thank__social {
  border-top: 1px solid var(--app-border);
  padding-top: 1.5rem;
  margin-top: 1rem;
}

.ew-thank__social-label {
  font-family: var(--app-font);
  color: var(--app-navy);
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.ew-social-icon {
  width: 1.6rem;
  display: inline-block;
  margin: 0 0.4rem;
}

@media (max-width: 350px) {
  .ew-result-indicator { width: 14rem; }
}
</style>



// WEBPACK FOOTER //
// src/components/ThankPage.vue